module.exports = __webpack_public_path__ + "img/Tom Butler.e17ec631.jpg";